import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8.5 8.5v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 15.5v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 12v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 17v.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 14v.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Cookie";
const Cookie = memo(themed(Icon));
export {
  Cookie
};
//# sourceMappingURL=cookie.js.map
